jQuery(document).ready(function ($) {


  jQuery("a[href='#']").attr("href", "javascript:void(0)");
  addOpacityToHeader();
  jQuery(document).on(
    "click",
    ".site-header .primary_mobile_menu",
    function () {
      if (jQuery(this).hasClass("active")) {
        jQuery("body").removeClass("mobile_menu_open");
        jQuery(this).removeClass("active");
        jQuery(this).find(".menu_link_text").text("Menu");
      } else {
        jQuery("body").addClass("mobile_menu_open");
        jQuery(this).addClass("active");
        jQuery(this).find(".menu_link_text").text("Close");
      }
    }
  );

  jQuery(document).on(
    "click",
    ".site-header .menu-item.menu-item-has-children>a",
    function () {
      if (jQuery(this).parent().find(".sub-menu").is(":hidden")) {
        jQuery(".site-header .menu-item.menu-item-has-children>a").removeClass(
          "active"
        );
        jQuery(
          ".site-header .menu-item.menu-item-has-children>.sub-menu"
        ).slideUp();
        jQuery(this).addClass("active");
        jQuery(this).parent().find(".sub-menu").slideDown();
      } else {
        jQuery(this).removeClass("active");
        jQuery(this).parent().find(".sub-menu").slideUp();
      }
    }
  );

  if ($(".site-header.theme_blue").length) {
    var topBar = $(".site-header.theme_blue").outerHeight();
    $(".site-content").css("padding-top", topBar + "px");
  }

  jQuery(document).on(
    "click",
    ".site-header .menu-item.contact_sec_link , #contact_sec_open_btn",
    function () {
      if (jQuery(".contact_drop_down").is(":hidden")) {
        jQuery(".contact_drop_down").slideDown();
      }
    }
  );
  jQuery(document).on(
    "click",
    "#contact_form_close_btn , .close_btn_contact ",
    function () {
      if (jQuery(".contact_drop_down").is(":visible")) {
        jQuery(".contact_drop_down").slideUp();
      }
    }
  );

  $(".insights_post_list_popup__item_inner").click(function () {
    setTimeout(function () {
      $("body").addClass("insights_post_list_popup_open");
    });
  });

  $(".insights_post_list_popup__item_inner.Video").click(function () {
    setTimeout(function () {
      $("body").addClass("insights_post_list_popup_open");
      $("body").addClass("insights_video_popup_open");
    });
  });

  jQuery(document).on("lity:close", function (event, instance) {
    jQuery("body").removeClass("insights_post_list_popup_open");
    jQuery("body").removeClass("insights_video_popup_open");
  });
});

jQuery(window).on("scroll", function () {
  addOpacityToHeader();
});

function addOpacityToHeader() {
  if (jQuery(window).scrollTop() > 150) {
    jQuery("header.site-header").addClass("sticky_background");
  } else {
    jQuery("header.site-header").removeClass("sticky_background");
  }
}

jQuery(window).resize(function () {
  if (jQuery(".site-header.theme_blue").length) {
    var topBar = jQuery(".site-header.theme_blue").outerHeight();
    jQuery(".site-content").css("padding-top", topBar + "px");
  }
});
